"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKiotaTree = getKiotaTree;
const rpc = __importStar(require("vscode-jsonrpc/node"));
const connect_1 = __importDefault(require("../connect"));
/**
 * Shows the Kiota result based on the provided options.
 *
 * @param {KiotaResultOptions} options - The options to configure the Kiota result.
 * @param {string} options.descriptionPath - The path to the description file.
 * @param {string[]} [options.includeFilters] - Filters to include in the result.
 * @param {string[]} [options.excludeFilters] - Filters to exclude from the result.
 * @param {boolean} [options.clearCache] - Whether to clear the cache before showing the result.
 * @param {boolean} [options.includeKiotaValidationRules] - Whether to evaluate built-in kiota rules when parsing the description file.
 * @returns {Promise<KiotaTreeResult | undefined>} A promise that resolves to the Kiota show result or undefined if an error occurs.
 * @throws {Error} Throws an error if the result is an instance of Error.
 */
async function getKiotaTree({ descriptionPath, includeFilters, excludeFilters, clearCache, includeKiotaValidationRules }) {
    const result = await (0, connect_1.default)(async (connection) => {
        const request = new rpc.RequestType('Show');
        const result = await connection.sendRequest(request, {
            includeFilters: includeFilters ?? [],
            excludeFilters: excludeFilters ?? [],
            descriptionPath,
            clearCache: clearCache ?? false,
            includeKiotaValidationRules: includeKiotaValidationRules ?? false,
        });
        return result;
    });
    if (result instanceof Error) {
        throw result;
    }
    return result;
}
;
//# sourceMappingURL=getKiotaTree.js.map